export default "__VITE_ASSET__CVroK5Fe__"